import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function isValidIp(value: string): boolean {
    if (!value) {
        return false;
    }
    const octets = value.split('.');
    if (octets.length !== 4 || !octets.every((octet: string) => octet.length > 0)) {
        return false;
    }
    return octets.every((octet: string) => {
        const num = parseInt(octet, 10);
        return !isNaN(num) && num >= 0 && num <= 255;
    });
}

export function ipValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        return isValidIp(value) ? null : {invalidIp: true};
    };
}
